import { motion } from "framer-motion";
import { Mail, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ABSTRACT_VISUAL =
  "https://static.prod-images.emergentagent.com/jobs/c4123765-4681-4e75-86dd-45916bba434c/images/06027a5a28d0e8baec6ce8cc480c8f4dd1673451e36ccd8cf2a7d3f5698a6328.png";

const EMAIL = "patrick@profitoperators.com";

const FinalCTA = () => {
  const { t } = useLang();
  return (
    <section id="contact" className="relative py-32 md:py-44 overflow-hidden">
      {/* Abstract 3D visual background — emerald geometry, no portrait */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <img
          src={ABSTRACT_VISUAL}
          alt=""
          className="absolute -right-[8%] top-1/2 -translate-y-1/2 h-[140%] w-auto max-w-none object-cover opacity-60 mix-blend-screen select-none"
          draggable={false}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-po-bg via-po-bg/85 to-po-bg/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-po-bg via-transparent to-po-bg/60" />
      </div>
      <div
        className="glow-orb"
        style={{ width: 700, height: 700, background: "rgba(16,185,129,0.20)", top: -100, left: -200 }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="max-w-5xl"
        >
          <div className="text-[11px] tracking-[0.3em] uppercase text-po-accent mb-6">
            {t.finalCta.eyebrow}
          </div>
          <h2 className="font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[88px] tracking-[-0.04em] font-bold leading-[0.95]">
            {t.finalCta.title}
            <br />
            <span className="font-serif-it text-po-accent">{t.finalCta.titleItalic}</span>
          </h2>
          <p className="mt-8 max-w-2xl text-po-text2 text-base sm:text-lg leading-relaxed">
            {t.finalCta.sub}
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5">
            <a
              href={`mailto:${EMAIL}?subject=Partnership%20Inquiry`}
              data-testid="final-cta-mail"
              className="btn-glow inline-flex items-center gap-2 bg-po-accent text-[#04140C] font-semibold rounded-full px-7 py-4 text-[15px]"
            >
              <Mail className="h-4 w-4" />
              {t.finalCta.cta}
              <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="final-cta-email-link"
              className="text-po-text2 hover:text-white transition text-[15px] underline underline-offset-4 decoration-po-accent/40 hover:decoration-po-accent"
            >
              {EMAIL}
            </a>
          </div>

          <p className="mt-6 max-w-xl text-po-text2 text-[15px]">
            {t.finalCta.mail}{" "}
            <a
              href={`mailto:${EMAIL}`}
              className="text-po-accent hover:underline"
              data-testid="final-cta-email-inline"
            >
              {EMAIL}
            </a>{" "}
            {t.finalCta.mailSuffix}
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.2em] text-po-text3">{t.finalCta.micro}</p>

          <div className="mt-16 inline-flex items-center gap-3 px-5 py-3 rounded-full border border-po-accent/20 bg-po-accent/[0.05] text-[12px] tracking-[0.22em] uppercase text-po-accent">
            <span className="h-1.5 w-1.5 rounded-full bg-po-accent animate-pulse shadow-[0_0_10px_rgba(16,185,129,0.8)]" />
            {t.finalCta.tagline}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
